<template>
  <v-row align="center">
    <v-col cols="3">
      <v-list-item>
        <v-list-item-avatar>
          <v-img :src="avatar_img" />
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>
            {{ nome[0] }}
          </v-list-item-title>
          <v-list-item-subtitle>
            {{ nome[1] }}
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-col>
    <v-col cols="2">
      <v-row v-for="zona in coltura.zona_attuale" :key="'z-' + zona">
        {{ get_zona(zona).nome }}
      </v-row>
      <v-row
        v-for="id_serra in coltura.serra_attuale"
        :key="'s-' + id_serra"
        class="blue--text text--darken-1"
      >
        <v-icon x-small color="blue darken-1" class="mr-1"
          >mdi-map-marker-radius-outline</v-icon
        >{{ nome_serra(id_serra) }}
      </v-row>
    </v-col>
    <v-col cols="2">
      {{ data_trapianto }}
    </v-col>
    <v-col cols="1">
      {{ data_posizionamento }}
    </v-col>
    <v-col cols="2" class="d-flex justify-center">
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon @click="modifica_stato()" v-bind="attrs" v-on="on">
            <v-icon v-if="coltura.esaurito" color="red">mdi-close</v-icon>
            <v-icon v-else color="green">mdi-check</v-icon>
          </v-btn>
        </template>
        <span v-if="coltura.esaurito">{{ testo_esaurito }}</span>
        <span v-else>Segna come esaurito</span>
      </v-tooltip>
    </v-col>
    <v-col cols="2" class="d-flex justify-center">
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            icon
            small
            color="grey darken-1"
            v-bind="attrs"
            v-on="on"
            @click="$refs.storia.open(id_lotto, coltura)"
          >
            <v-icon>mdi-history</v-icon>
          </v-btn>
        </template>
        <span>Storia completa</span>
      </v-tooltip>
      <StoriaLottoDialog ref="storia" />
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            icon
            small
            color="teal"
            v-bind="attrs"
            v-on="on"
            @click="$refs.serra_picker.open()"
          >
            <v-icon>mdi-greenhouse</v-icon>
          </v-btn>
        </template>
        <span>Sposta in un'altra serra (mappa)</span>
      </v-tooltip>
      <SerraPickerDialog
        ref="serra_picker"
        :value="coltura.serra_attuale"
        require_selection
        @conferma="sposta_serra"
      />
      <v-menu v-model="menu_delete">
        <template v-slot:activator="{ on }">
          <v-btn small color="red" icon v-on="on"
            ><v-icon>mdi-delete</v-icon></v-btn
          >
        </template>
        <v-card>
          <v-card-title>Sei Sicuro ?</v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="grey" text @click="menu_delete = false"
              >annulla</v-btn
            >
            <v-btn color="red" outlined @click="elimina_coltura()"
              >Elimina</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-menu>
    </v-col>
  </v-row>
</template>

<script>
import moment from "moment";
import SerraPickerDialog from "@/components/PianoColtivazione/Desktop/SerraPickerDialog.vue";
import StoriaLottoDialog from "./storia_lotto_dialog.vue";
export default {
  components: { SerraPickerDialog, StoriaLottoDialog },
  props: {
    id_lotto: String,
    coltura: Object,
  },
  data() {
    return {
      menu_delete: false,
    };
  },
  computed: {
    prodotto() {
      return this.$store.getters.get_prodotto_by_id(this.coltura.id_prodotto);
    },
    nome() {
      return this.prodotto.nome.split(" in ");
    },
    avatar_img() {
      return process.env.VUE_APP_API_ROOT + "/avatar_img/" + this.prodotto.id;
    },
    data_trapianto() {
      return moment.unix(this.coltura.ts_trapianto).format("DD/MM/YYYY");
    },
    data_posizionamento() {
      return moment.unix(this.coltura.ts_posizionamento).format("DD/MM/YYYY");
    },
    testo_esaurito() {
      if (!this.coltura.ts_esaurito) return "Esaurito (data non disponibile)";
      return "Esaurito " + moment.unix(this.coltura.ts_esaurito).fromNow();
    },
  },
  methods: {
    // Lo spostamento tramite la vecchia Zona è stato abolito: get_zona resta
    // solo per visualizzare zona_attuale/zone_precedenti storici, finché non
    // vengono cancellati dal primo spostamento via mappa su quella coltura.
    get_zona(id) {
      return this.$store.getters.get_zona_by_id(id);
    },
    nome_serra(id) {
      let serra = this.$store.getters.getSerraById(id);
      return serra ? serra.nome : id;
    },
    sposta_serra(nuove_serre) {
      this.$store.dispatch("sposta_lotto_zona_coltura", {
        id_lotto: this.id_lotto,
        id_coltura: this.coltura.id,
        serre_destinazione: nuove_serre,
        ts_posizionamento: moment().format("X"),
      });
    },
    modifica_stato() {
      this.$store.dispatch("cambia_stato_produzione_coltura", {
        id_lotto: this.id_lotto,
        id_coltura: this.coltura.id,
        esaurito: !this.coltura.esaurito,
      });
    },
    elimina_coltura() {
      this.$store.dispatch("elimina_coltura_lotto", {
        id_lotto: this.id_lotto,
        id_coltura: this.coltura.id,
      });
    },
  },
};
</script>